import { render } from "./Profile.vue?vue&type=template&id=1b04776c&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=1b04776c&scoped=true&lang=css"

import exportComponent from "D:\\01_Dev_Env_And_Workspace\\01_Active_Projects\\Vue_Frontend\\notemd-web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_29d074f7dbbfd97370df878da6275bc8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b04776c"]])

export default __exports__